import { lazy } from 'react';
const SettingsPage = lazy(() => import(/* webpackChunkName: "settings" */ '.'));
export default SettingsPage;
